var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2917 23.1667H24.6458L24.0625 22.6042C26.1042 20.2292 27.3333 17.1458 27.3333 13.7917C27.3333 6.3125 21.2708 0.25 13.7917 0.25C6.3125 0.25 0.25 6.3125 0.25 13.7917C0.25 21.2708 6.3125 27.3333 13.7917 27.3333C17.1458 27.3333 20.2292 26.1042 22.6042 24.0625L23.1667 24.6458V26.2917L33.5833 36.6875L36.6875 33.5833L26.2917 23.1667ZM13.7917 23.1667C8.60417 23.1667 4.41667 18.9792 4.41667 13.7917C4.41667 8.60417 8.60417 4.41667 13.7917 4.41667C18.9792 4.41667 23.1667 8.60417 23.1667 13.7917C23.1667 18.9792 18.9792 23.1667 13.7917 23.1667Z",
    fill: "#1A0154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d4ab8140.svg";
export { ForwardRef as ReactComponent };